// @flow

// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import { last, partial } from 'lodash';

export const ensureArray = (value: mixed) =>
  Array.isArray(value) ? value : [value];

// Simple plurals only! It just adds an `s` or an `es` if the noun ends with s.
// we should probably make this more robust to include these rules:
// https://www.englisch-hilfen.de/en/grammar/plural.htm
export const pluralize = (noun: string, number: number) => {
  const endsWithS = last(noun.split('')) === 's';
  const sOrEs = endsWithS ? 'es' : 's';
  return `${noun}${number !== 1 ? sOrEs : ''}`;
};

export const uninfinitizeWith = (alt: number, num: number) =>
  num === Infinity ? alt : num;

export const uninfinitize = partial(uninfinitizeWith, 'unlimited');

export const clamp = (min: number, max: number, val: number) =>
  Math.max(min, Math.min(val, max));

export const infinitize = (num: number | string) =>
  num === -1 || num === 'unlimited' ? Infinity : num;
